import { lazy } from 'react';
import { QueryClient } from '@tanstack/react-query';
import {
	experimental_createQueryPersister,
	type AsyncStorage,
} from '@tanstack/react-query-persist-client';
import { get, set, del, createStore, type UseStore } from 'idb-keyval';

export const ReactQueryDevtoolsProduction = lazy(() =>
	import('@tanstack/react-query-devtools/build/modern/production.js').then(
		(d) => ({
			default: d.ReactQueryDevtools,
		}),
	),
);

const persister = experimental_createQueryPersister({
	storage: idbStorage(createStore('canvasflow_db', 'react-query-cache')),
	prefix: 'cf-query',
	maxAge: 1000 * 60 * 60 * 12, // 12 hours,
	// Just pass the data
	serialize: (persistedQuery: any) => persistedQuery,
	deserialize: (cache: any) => cache,
});

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: 1000 * 2,
			staleTime: 1000 * 10,
			refetchInterval: 1000 * 30,
			persister: persister.persisterFn,
		},
	},
});

function idbStorage(idbStore: UseStore): AsyncStorage {
	return {
		getItem: async (key) => get(key, idbStore),
		setItem: async (key, value) => set(key, value, idbStore),
		removeItem: async (key) => del(key, idbStore),
	};
}
